export const FAULU_LOAN_CALCULATOR_FORM_TRANSITION = 'fauluLoanCalculator/fauluLoanCalculatorForm/transition/';

export const FORM_VALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION = 'fauluLoanCalculator/fauluLoanCalculatorForm/formValid';
export const FORM_INVALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION = 'fauluLoanCalculator/fauluLoanCalculatorForm/formInvalid';

export const FAULU_LOAN_CALCULATOR_FORM_SET_VALUE = 'fauluLoanCalculator/fauluLoanCalculatorForm/setValue/';
export const FAULU_LOAN_CALCULATOR_FORM_SET_VALID = 'fauluLoanCalculator/fauluLoanCalculatorForm/setValid/';

export const API_INITIAL_TRANSITION_STATUS = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + '/api/transition/initial';
export const API_SUCCESS_TRANSITION_STATUS = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + '/api/transition/success';
export const API_FAILURE_TRANSITION_STATUS = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + '/api/transition/failure';
export const API_PENDING_TRANSITION_STATUS = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + '/api/transition/pending';

export const apiTransitionFauluLoan = {
    initial: () => ({
        type: API_INITIAL_TRANSITION_STATUS,
    }),
    pending: () => ({
        type: API_PENDING_TRANSITION_STATUS,
    }),
    success: () => ({
        type: API_SUCCESS_TRANSITION_STATUS,
    }),
    failure: () => ({
        type: API_FAILURE_TRANSITION_STATUS,
    }),
};

export const transitionFauluLoanCalculatorForm = {
    formValid: () => ({ type: FORM_VALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION }),
    formInvalid: () => ({ type: FORM_INVALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION }),
};

export const RESET_CALCULATOR_FORM = 'fauluLoanCalculator/fauluLoanCalculatorForm/reset/form';
export const resetCalculatorForm = () => ({ type: RESET_CALCULATOR_FORM });
export const TOKEN_IS_EXPIRED = 'fauluLoanCalculator/expiredAuth';

export const REINITIALIZE_STATE_FAULU_LOAN_CALCULATOR_FORM = 'fauluLoanCalculator/fauluLoanCalculatorForm/reinitialize';

export const REPAYMENT_DURATION_SET_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'repaymentDuration';
export const REPAYMENT_DURATION_SET_VALID = FAULU_LOAN_CALCULATOR_FORM_SET_VALID + 'repaymentDuration';

export const DURATION_SET_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'duration';
export const DURATION_SET_VALID = FAULU_LOAN_CALCULATOR_FORM_SET_VALID + 'duration';

export const INTEREST_SET_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'interest';
export const INTEREST_SET_VALID = FAULU_LOAN_CALCULATOR_FORM_SET_VALID + 'interest';

export const LOAN_AMOUNT_SET_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'loanAmount';
export const LOAN_AMOUNT_SET_VALID = FAULU_LOAN_CALCULATOR_FORM_SET_VALID + 'loanAmount';

export const LOAN_RESULT_SET_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'loanResult';
export const LOAN_CALCULATE_SET_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'loanCompute';

export const FAULU_LOAN_SIDEBAR_OPEN_VALUE = FAULU_LOAN_CALCULATOR_FORM_SET_VALUE + 'sidebarOpen';

export const setLoanAmountValue = value => ({ type: LOAN_AMOUNT_SET_VALUE, value });
export const setLoanAmountValid = error => ({ type: LOAN_AMOUNT_SET_VALID, error });

export const setDurationValue = value => ({ type: DURATION_SET_VALUE, value });
export const setDurationValid = error => ({ type: DURATION_SET_VALID, error });

export const setRepaymentDurationValue = value => ({ type: REPAYMENT_DURATION_SET_VALUE, value });
export const setRepaymentDurationValid = error => ({ type: REPAYMENT_DURATION_SET_VALID, error });

export const setInterestValue = value => ({ type: INTEREST_SET_VALUE, value });
export const setInterestValid = error => ({ type: INTEREST_SET_VALID, error });

export const setLoanResultValue = value => ({ type: LOAN_RESULT_SET_VALUE, value });
export const setComputeLoanValue = value => ({ type: LOAN_CALCULATE_SET_VALUE });

export const setSideBarOpen = (value) => ({ type: FAULU_LOAN_SIDEBAR_OPEN_VALUE, value });

export const reInitialize = () => ({ type: REINITIALIZE_STATE_FAULU_LOAN_CALCULATOR_FORM });

export const setExpiredAuth = (value) => ({ type: TOKEN_IS_EXPIRED, value });